import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-norway',
    templateUrl: './norway.component.html',
    styleUrls: ['./norway.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NorwayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
